/**
 * Deutsche Eingabe zulassen: „8,50" ist hier das Normale, nicht die Ausnahme. Gibt `null`
 * zurück, wenn daraus kein gültiger Preis wird — der Aufrufer entscheidet über die Meldung.
 */
export function parsePrice(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }
  const value = Number(trimmed.replace(',', '.'));
  return Number.isFinite(value) && value >= 0 ? value : null;
}
